import React from 'react'
import parser from 'html-react-parser'
import {wrapperPadding} from './ContentBlocks6.module.css'

export default function ContentBlocks6({ data }) {
    const { contentBlocks6Title, contentBlocks6Blocks } = data
    return (
        <div className={`${wrapperPadding}`}>
            <div className='container imapct-vid-cont yt-video-cont'>
                <div className='row'>                    
                    <h3 className='heading-level-3 mb-2 black-color text-center'>
                        {contentBlocks6Title && parser(contentBlocks6Title)}
                    </h3>
                </div>
            </div>
            <div className='container'>
                <div className='row d-green-box-row'>
                    {contentBlocks6Blocks.map((block, i) => {
                        return (
                            <div className='col-md-6 d-green-col-md' key={i}>
                                <div className='green-col-1 d-green-bx'>
                                    <p>{block.contentBlocks6BlockText &&  parser(block.contentBlocks6BlockText)}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}
